import React, { useState } from "react";

import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  FormControlLabel,
  Switch,
  Stack,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SchoolIcon from "@mui/icons-material/School";
import { motion } from "framer-motion";
import Swal from "sweetalert2";
import api from "../../api/api";
import { useAcademicYear } from "../../AcademicYearContext";


const AddAcademyYear = ({ open, handleClose }) => {


  const {
    fetchAcademicYears
  } = useAcademicYear();


  const [formData, setFormData] = useState({
    name: "",
    start_date: "",
    end_date: "",
    is_active: false,
  });


  const [loading, setLoading] = useState(false);



  const handleChange = (e) => {

    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

  };

const handleSubmit = async (e) => {

  e.preventDefault();

  setLoading(true);

  try {

    const response = await api.post(
      "/academic-years/",
      formData
    );


    Swal.fire({
      icon:"success",
      title:"Academic Year Added",
      text:`${response.data.name} has been created successfully.`,
      timer:2000,
      showConfirmButton:false,
    });



    setFormData({
      name:"",
      start_date:"",
      end_date:"",
      is_active:false,
    });



    // ✅ THIS UPDATES THE DROPDOWN WITHOUT REFRESH
    await fetchAcademicYears();


    // ✅ Notify all listeners
    window.dispatchEvent(
      new Event("academic-year-updated")
    );


    handleClose();



  } catch(error){

    console.log(error.response);


    Swal.fire({
      icon:"error",
      title:"Failed",
      text:
      error.response?.data?.name?.[0] ||
      "Unable to create academic year",
    });


  } finally {

    setLoading(false);

  }

};



  return (

    <Dialog

      open={open}

      onClose={handleClose}

      maxWidth="sm"

      fullWidth

      PaperProps={{
        component: motion.div,

        initial:{
          opacity:0,
          y:-50,
          scale:0.9
        },

        animate:{
          opacity:1,
          y:0,
          scale:1
        },

        transition:{
          duration:0.35
        },

        sx:{
          borderRadius:"20px",
          overflow:"hidden"
        }
      }}

    >


      <DialogContent>


        {/* Header */}

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
        >


          <Box display="flex" alignItems="center" gap={1}>


            <SchoolIcon
              color="primary"
              sx={{
                fontSize:35
              }}
            />


            <Typography
              variant="h5"
              fontWeight="700"
            >

              Add Academic Year

            </Typography>


          </Box>



          <IconButton onClick={handleClose}>

            <CloseIcon />

          </IconButton>


        </Box>




        <form onSubmit={handleSubmit}>


          <Stack spacing={3}>


            <TextField

              label="Academic Year Name"

              name="name"

              placeholder="Example: 2027/2028"

              value={formData.name}

              onChange={handleChange}

              fullWidth

              required

              InputProps={{
                startAdornment:
                <SchoolIcon
                  sx={{
                    mr:1,
                    color:"gray"
                  }}
                />
              }}

            />





            <TextField

              label="Start Date"

              type="date"

              name="start_date"

              value={formData.start_date}

              onChange={handleChange}

              fullWidth

              required

              InputLabelProps={{
                shrink:true
              }}

              InputProps={{
                startAdornment:
                <CalendarMonthIcon
                  sx={{
                    mr:1,
                    color:"gray"
                  }}
                />
              }}

            />





            <TextField

              label="End Date"

              type="date"

              name="end_date"

              value={formData.end_date}

              onChange={handleChange}

              fullWidth

              required


              InputLabelProps={{
                shrink:true
              }}


              InputProps={{
                startAdornment:
                <CalendarMonthIcon
                  sx={{
                    mr:1,
                    color:"gray"
                  }}
                />
              }}


            />






            <Box

              sx={{

                background:"#f8f9fa",

                borderRadius:3,

                p:1.5

              }}

            >


              <FormControlLabel


                control={

                  <Switch

                    checked={
                      formData.is_active
                    }


                    onChange={(e)=>

                      setFormData({

                        ...formData,

                        is_active:e.target.checked

                      })

                    }


                    color="primary"

                  />

                }


                label={

                  <Typography fontWeight="600">

                    Set as Active Academic Year

                  </Typography>

                }


              />


            </Box>






            <Button

              type="submit"

              variant="contained"

              size="large"

              disabled={loading}

              sx={{

                borderRadius:"12px",

                py:1.5,

                fontWeight:"700",

                textTransform:"none",

                fontSize:"16px"

              }}

            >


              {loading 
                ? "Saving..."
                : "Add Academic Year"
              }


            </Button>



          </Stack>



        </form>



      </DialogContent>



    </Dialog>

  );

};



export default AddAcademyYear;